import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PurchaseItemPriceService } from 'pages/quote-setup/purchase-item-prices/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(PurchaseItemPriceService, DialogService, EventAggregator)
export class PurchaseItemPrices {
    constructor(purchaseItemPriceService, dialogService, ea) {
        this.ea = ea;
        this.purchaseItemPriceService = purchaseItemPriceService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'childPartNumber', sortOrder: 'asc', caption: 'Child Part', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'plantName', caption: 'Plant' },
            { dataField: 'parentPartNumber', caption: 'Parent Part'},
            { dataField: 'projectNumber', caption: 'Project' },
            { dataField: 'salesPrice', caption: 'Price' },
            { dataField: 'sga', caption: 'SGA' },
            { dataField: 'profit', caption: 'Profit' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('purchase-item-price:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (purchaseItemPrice) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.purchaseItemPriceService.delete(purchaseItemPrice.id);
                this.grid.refresh();
                toastr.success('Purchase item price was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.purchaseItemPriceService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.purchaseItemPriceService.editor, model: { id: data.id } });
    };
}
